import { render, staticRenderFns } from "./RecommendBanner.vue?vue&type=template&id=dd11c24e&"
import script from "./RecommendBanner.vue?vue&type=script&lang=js&"
export * from "./RecommendBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/hanmail/src/cafe-top/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('dd11c24e', component.options)
    } else {
      api.reload('dd11c24e', component.options)
    }
    module.hot.accept("./RecommendBanner.vue?vue&type=template&id=dd11c24e&", function () {
      api.rerender('dd11c24e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/components/home/RecommendBanner.vue"
export default component.exports